<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type='primary' @click="savepqc" :loading="btnLoading">保存</el-button>
      <vxe-button v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button>
    </div>
    <div class="main">
      <el-form :model="pqc" ref="ruleForm" label-position="right" class="mainfrom from_input">
        <div class="row">
          <el-form-item label="顺序号" prop="pqcitemseq" verify int :gt="0">
            <el-input v-model="pqc.pqcitemseq" :maxlength="6" :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="初审类型" prop="pqcitemchecktype" verify>
            <el-select v-model="pqc.pqcitemchecktype" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in pqcitemchecktypeList" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="初审内容" prop="pqcitemcheckcontent" verify>
            <el-input v-model="pqc.pqcitemcheckcontent" :maxlength="5000" :autosize="{ minRows: 15}" show-word-limit type="textarea" :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <!--<div class="row">-->
          <!--<el-form-item label="初审要求"  prop="pqcitemcheckdemand" verify>-->
            <!--<el-input v-model="pqc.pqcitemcheckdemand" :maxlength="255" show-word-limit type="textarea" :disabled="disable"></el-input>-->
          <!--</el-form-item>-->
        <!--</div>-->
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  import vggrid from '../common/vggrid'
  export default {
    name: "pqcFrom",
    mixins: [common],
    data () {
      return {
        pqc:this.$route.params.form,
        pqcitemchecktypeList:[],
        disable:false,
        loading:false,
        btnLoading:false
      }
    },
    created () {},
    activated () {
      this.init()
      this.getpqcitemchecktypeList()
      this.pqc.pqcitemchecktype = this.pqc.pqcitemchecktype.toString()
    },
    watch: {},
    filters: {},
    components: {vggrid},
    computed: {
    },
    deactivated () {
    },
    methods: {
        async init(){
            this.pqc=this.$route.params.form
        },
        async savepqc(){
            this.loading = true
            this.submitForm('ruleForm').then(async() => {
                let data = await request({
                    url: '/ywgl/qcm/savepqc',
                    method: "post",
                    data: this.pqc
                })
                if (data.issuccess===1) {
                    this.close()
                    this.$message.success('保存成功')
                } else {
                    this.$message.error('保存失败')
                }
            }).catch((err) => {
                console.log('======err======',err);
            })
            this.loading = false
        },
        async getpqcitemchecktypeList(){
            this.pqcitemchecktypeList = await request({
                url: '/kfgl/syscode/getSysCodeList',
                method: "get",
                params: {syscode: 'qcmchecktype'}
            })
        },
        close () {
          this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
        },
    }
  }
</script>

<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea {
      width: 520px;
    }
  }
</style>
